import { logError } from '@marketplace-web/observability/logging-util'

import { CatalogFeature } from '../constants/catalog'

const LOG_PREFIX = 'Catalog'

export const logCatalogError = (error: Error | null, feature?: CatalogFeature) => {
  if (!(error instanceof Error)) return

  const loggedFeature = feature ? `${LOG_PREFIX}_${feature}` : LOG_PREFIX

  logError(error, { feature: loggedFeature })
}
